<template>
  <div
    v-if="['hungaryMap'].indexOf($route.name) > -1">
    <cbr-hu-map :show="true" />
  </div>
  <div
    v-else>
    <cbr-solo-map :show="true" />
  </div>
</template>

<script>
import CbrSoloMap from '../components/CbrSoloMap.vue'
import { mapState } from 'vuex'
import CbrHuMap from '../components/CbrHuMap.vue'

export default {
  components: {
    CbrSoloMap,
    CbrHuMap
  },
  computed: {
    ...mapState('config', ['identifier', 'config'])
  }
}
</script>
<style module>
.mask {
  z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// client/views/IframeMapHolder.vue